import { fromJS } from 'immutable';

import { MODAL_OPEN, MODAL_CLOSE } from '../../store/actions/Modal';

const initialState = fromJS({});

export default function modal(state = initialState, action = {}) {
  switch (action.type) {
    case MODAL_OPEN: {
      return state.set('entity', fromJS(action.payload));
    }

    case MODAL_CLOSE: {
      return state.delete('entity');
    }

    default:
      return state;
  }
}
